<template>

<fragment>

<div class="head-ghost" v-if="fixed" />

<div class="head" :class="{
    'has-actions': hasActions, 
    'is-fixed': fixed,
	'is-scrolled': isScrolled
}">

	<div 
		class="head-inner is-sticky inner" 
		:style="{
			gridTemplateColumns: gridSticky
		}"
		v-if="stickyFields.length"
	>

        <app-view-list-column v-for="field in stickyFields" :field="field" :filter="filter" :key="field.id" />

	</div>

	<div 
		class="head-inner inner" 
		:style="{
			gridTemplateColumns: gridFinal,
			marginLeft: marginLeft
		}"
	>

        <app-view-list-column v-for="field in fields" :field="field" :filter="filter" :key="field.id" />

		<core-list-column-actions v-if="hasActions" />

	</div>

</div>

</fragment>

</template>

<script>

export default {

	props: ['fields', 'grid', 'filter', 'fixed', 'gridSticky', 'stickyFields', 'left', 'isScrolled'],

    computed: {

		marginLeft: function() {

			return (this.left) ? (0 - this.left).toString() + 'px' : '0px'

		},

        hasActions: function() {

            return this.$route.meta.hasActions

        },

        gridFinal: function() {

            return this.grid + ' auto'

        }

    }

}

</script>

<style scoped>

.head-ghost {
	height: 32px;
}

.head {
	background-color: #fff;
	border-radius: 4px 4px 0px 0px;
	border: 1px solid #ddd;
	border-bottom: 0px;
	z-index: 2;
	overflow: hidden;
}

.head.is-scrolled {
	box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 10px;
}

.is-mobile .head {
	overflow: hidden;
	border-radius: 0px;
	border-left: 0px;
	border-right: 0px;
	border-bottom: 1px solid #ddd;
}

.is-desktop .head,
.is-tablet .head {
	transition: margin-left 100ms linear;
}

.is-mobile .head.is-fixed {
	position: fixed;
	top: 64px;
	left: 424px;
	z-index: 1000;
	border-radius: 0px;
	border-left-color: #fff;
	border-right-color: #fff;
	border-top: 0px;
	border-bottom: 1px solid #ddd;
	top: 49px;
	left: 0px;
	right: 0px;
	width: 100%;
	border-top: 1px solid #ddd;
	box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px;
}

.is-mobile .head.has-actions.is-fixed {
	top: 90px;
}

.head-offset {
	position: absolute;
	top: -32px;
	height: 32px;
	width: 32px;
}

.head.is-mobile {
	top: 136px;
}

.head.is-inline {
	position: relative;
	top: auto;
	left: auto;
	z-index: 1;
}

.head-inner {
	display: grid;
    grid-gap: 10px;
	width: 100%;
	padding: 0px 5px;
	height: 32px;
	z-index: 2;
}

.is-mobile .head-inner {
	grid-gap: 5px;
}

.head-inner.is-sticky {
	padding: 0px 10px;
	width: auto;
	background-color: #fff;
	position: absolute;
	z-index: 3;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

</style>